import styled from 'styled-components';

export const DesktopOnly = styled.div`
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileOnly = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
  }
`;

export const MobileOrderList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
`;

export const MobileOrderCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  background: white;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
`;

export const MobileOrderHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 14px;
  border: none;
  background: #f9fafb;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #f3f4f6;
  }
`;

export const MobileOrderHeaderMain = styled.div`
  flex: 1;
  min-width: 0;
`;

export const MobileOrderHeaderAside = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 8px;
  flex-shrink: 0;
`;

export const MobileOrderId = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 4px;
  word-break: break-word;
`;

export const MobileOrderMeta = styled.div`
  font-size: 13px;
  color: #6b7280;
  line-height: 1.4;
  word-break: break-word;
`;

export const MobileOrderTotal = styled.div`
  font-size: 15px;
  font-weight: 700;
  color: #1f2937;
  white-space: nowrap;
`;

export const MobileBadgeRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  justify-content: flex-end;
`;

export const MobileOrderBody = styled.div`
  border-top: 1px solid #e5e7eb;
`;

export const MobileCardBody = styled.div`
  padding: 14px;
`;

export const MobileCardActions = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const mobileCardStyles = `
  @media (max-width: 768px) {
    border-radius: 12px;
    margin: 0;
    width: 100%;
    border-left: 1px solid #e5e7eb;
    border-right: 1px solid #e5e7eb;
  }
`;

export const mobileActionButtonStyles = `
  @media (max-width: 768px) {
    width: 100%;
    justify-content: center;
    margin-left: 0;
    margin-bottom: 0;
  }
`;

export const mobileActionContainerStyles = `
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: stretch;
  }
`;
